<template>
  <div class="download">
    <p v-if="isWX" class="tip">
      {{ msg }}
    </p>
  </div>
</template>

<script>
import { appDownloadUrl } from '@/config/index';
export default {
  name: 'Download',
  data() {
    return {
      appDownloadUrl,
      isWX: false,
      msg:  '请使用手机自带浏览器打开此链接。'
    }
  },
  methods: {
    init() {
      const isWX = /MicroMessenger/i.test(window.navigator.userAgent)
      this.isWX = isWX

      const { NODE_ENV } = process.env
      const url = this.appDownloadUrl[NODE_ENV]

      if (!isWX) {
        window.location.href = `${url}&t=${+new Date()}`
      }
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="less" scoped>
  .tip {
    font-size: 46px;
    text-align: center;
    line-height: 200px;
  }
</style>